import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useFinishBooking } from 'src/features/bookings/api/hooks/use-finish-booking';

interface Props extends DialogActions {
  bookingToken: string;
}

export const FinishBookingDialog = ({
  open,
  onCancel,
  bookingToken,
}: Props) => {
  const { t } = useTranslation(['bookings', 'common']);

  const { mutate: finishBooking, isPending: isFinishingBooking } =
    useFinishBooking(onCancel);

  const handleFinishBooking = () => {
    finishBooking(bookingToken);
  };

  return (
    <Dialog
      variant="warning"
      open={open}
      onCancel={onCancel}
      onConfirm={handleFinishBooking}
      confirmButtonText={t(
        'bookings:common.finishBookingDialog.confirmButtonText',
      )}
      cancelButtonText={t('common:button.no')}
      isConfirmButtonSubmitting={isFinishingBooking}
      title={t('bookings:common.finishBookingDialog.title')}>
      <Typography variant="body2">
        {t('bookings:common.finishBookingDialog.message')}
      </Typography>
    </Dialog>
  );
};
